module.exports = __webpack_public_path__ + "static/img/20045B_1_3_4_C_20210407_fit.0ec4d3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20045B_1_3_4_C_20210407_fit.png
// module id = p9xc
// module chunks = 0